import { Injectable } from '@angular/core';
import { Message } from 'primeng/api/message';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertService {
    private msgsSubject = new Subject<Message[]>();
    public msgs: Observable<Message[]>;

    constructor() {
        this.msgs = this.msgsSubject.asObservable();
    }

    SetMessage(type: any, msg: string) {
        this.msgsSubject.next(null);       
        var messages = [{ severity: type, summary: msg, detail: '' }];
        this.msgsSubject.next(messages);
    }
}
